import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, TrendingUp, Eye, Search } from 'lucide-react';

const slides = [
  {
    icon: TrendingUp,
    title: 'Fortalecer a economia local',
    text: 'Mais renda circulando aqui = mais desenvolvimento na cidade e região'
  },
  {
    icon: Eye,
    title: 'Dar visibilidade de verdade',
    text: 'Seu negócio aparece onde as pessoas procuram, por bairro, categoria e necessidade.'
  },
  {
    icon: Search,
    title: 'Facilitar para quem compra',
    text: 'Busca simples + contato rápido (WhatsApp ou Instagram), informações objetivas.'
  }
];

export default function BenefitsSlider() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  useEffect(() => {
    if (!isAutoPlaying) return;
    
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [isAutoPlaying]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 10000);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 10000);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 10000);
  };

  const CurrentIcon = slides[currentSlide].icon;

  return (
    <section className="py-12 bg-gradient-to-br from-purple-50 to-white" data-testid="benefits-slider">
      <div className="max-w-4xl mx-auto px-4">
        {/* Title */}
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-8 text-[var(--primary)]" style={{ fontFamily: 'Manrope' }}>
          O Empreende Comunidade existe para:
        </h2>

        {/* Slider Container */}
        <div className="relative">
          {/* Navigation Arrows */}
          <button
            onClick={prevSlide}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 z-10 w-10 h-10 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-all hidden md:flex"
            aria-label="Slide anterior"
          >
            <ChevronLeft className="w-5 h-5 text-[var(--primary)]" />
          </button>

          <button
            onClick={nextSlide}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 z-10 w-10 h-10 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-all hidden md:flex"
            aria-label="Próximo slide"
          >
            <ChevronRight className="w-5 h-5 text-[var(--primary)]" />
          </button>

          {/* Slide Content */}
          <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 text-center transition-all duration-500">
            {/* Icon */}
            <div className="w-20 h-20 mx-auto mb-6 bg-gradient-to-br from-[var(--primary)] to-purple-600 rounded-2xl flex items-center justify-center shadow-lg transform transition-transform duration-500">
              <CurrentIcon className="w-10 h-10 text-white" />
            </div>

            {/* Title */}
            <h3 className="text-xl md:text-2xl font-bold mb-4 text-gray-900" style={{ fontFamily: 'Manrope' }}>
              {slides[currentSlide].title}
            </h3>

            {/* Text */}
            <p className="text-gray-600 text-lg max-w-md mx-auto leading-relaxed">
              {slides[currentSlide].text}
            </p>
          </div>

          {/* Dots Navigation */}
          <div className="flex items-center justify-center gap-2 mt-6">
            {slides.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`w-3 h-3 rounded-full transition-all duration-300 ${
                  index === currentSlide
                    ? 'bg-[var(--primary)] w-8'
                    : 'bg-gray-300 hover:bg-gray-400'
                }`}
                aria-label={`Ir para slide ${index + 1}`}
              />
            ))}
          </div>

          {/* Mobile Swipe Hint */}
          <p className="text-center text-sm text-gray-400 mt-4 md:hidden">
            Deslize para ver mais
          </p>
        </div>
      </div>
    </section>
  );
}
